import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import {
    SocialType,
    TransversalFooter,
    TransversalFooterData,
} from '@comfama/comfama-ui-react';

// Contentful usa "x" para el nombre de la red social; la librería solo reconoce "twitter".
const SOCIAL_TYPE_ALIASES: Partial<Record<string, SocialType>> = {
    x: 'twitter',
};

const FooterTransversal = () => {
    const { allContentfulFooterTrasnversal } = useStaticQuery(graphql`
        query GET_FOOTER_TRANSVERSAL_CONTENT {
            allContentfulFooterTrasnversal(
                filter: {
                    contentful_id: { eq: "5U1m0rcQzVlWdNyecMYVgC" }
                }
            ) {
                nodes {
                    rrss {
                        name
                        url
                    }
                    seccionDeEnlaces {
                        title
                        content {
                            type
                            text
                            url
                        }
                    }
                }
            }
        }
    `);

    const footerNode = allContentfulFooterTrasnversal.nodes[0];

    const content: TransversalFooterData = {
        social: footerNode.rrss.map((social: any) => ({
            name: (SOCIAL_TYPE_ALIASES[social.name] ??
                social.name) as SocialType,
            url: social.url,
        })),
        columns: footerNode.seccionDeEnlaces.map((section: any) => ({
            title: section.title,
            content: section.content.map((item: any) => ({
                type: item.type,
                text: item.text,
                url: item.url ?? undefined,
            })),
        })),
    };

    return <TransversalFooter content={content} />;
};

export default FooterTransversal;
